module.exports = __webpack_public_path__ + "img/totalicon02.ea511ed3.png";